/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'well_balanced',
    quality: 0.4,
    dexterity: 2,
    damageMod: 0.1
}